/**
 * The key/value configuration entries of the API (`config/configs`), such as
 * the stock integration switches, and their update (`PUT config`).
 */
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/shared/api/client';

const appConfigEntrySchema = z.object({
  type: z.string().nullish(),
  value: z.unknown(),
});

export type AppConfigEntry = z.infer<typeof appConfigEntrySchema>;

export const appConfigsQueryKey = ['app-configs'] as const;

export const appConfigsQueryOptions = () =>
  queryOptions({
    queryKey: appConfigsQueryKey,
    queryFn: () =>
      api.get<AppConfigEntry[]>('config/configs', {
        schema: z.array(appConfigEntrySchema),
      }),
    staleTime: 60_000,
    retry: false,
  });
export const configFlag = (
  configs: readonly AppConfigEntry[] | undefined,
  type: string,
): boolean => !!(configs ?? []).find((entry) => entry.type === type)?.value;

/** The entries edited from the UI are switches: only booleans are sent. */
export const updateAppConfig = (type: string, value: boolean) =>
  api.put<unknown>('config', { type, value });
